// File: src/components/car/TopFeaturesModal.jsx
import React, { useState } from 'react';
import './TopFeaturesModal.css';

const TopFeaturesModal = ({ isOpen, onClose, features, car, onBookNow, onTestDrive }) => {
  const [activeCategory, setActiveCategory] = useState('SAFETY');
  const [searchQuery, setSearchQuery] = useState('');

  if (!isOpen) return null;

  // Define category order and labels matching Spinny
  const categoryConfig = {
    'SAFETY': { label: 'Safety', icon: '🛡️' },
    'COMFORT & CONVENIENCE': { label: 'Comfort & convenience', icon: '⭐' },
    'ENTERTAINMENT & COMMUNICATION': { label: 'Entertainment & communication', icon: '📱' },
    'INTERIOR': { label: 'Interior', icon: '🪑' },
    'EXTERIOR': { label: 'Exterior', icon: '🚗' },
    'HIGHLIGHT': { label: 'Highlight', icon: '✨' }
  };

  // Get available categories from features
  const availableCategories = Object.keys(features).filter(cat => 
    features[cat] && features[cat].length > 0
  );

  // Filter features based on search
  const getFilteredFeatures = () => {
    if (!searchQuery) return features[activeCategory] || [];
    
    return (features[activeCategory] || []).filter(feature =>
      feature.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  const handleTestDrive = () => {
    onClose(); // Close modal first
    if (onTestDrive) {
      onTestDrive(); // Call the test drive handler from parent
    }
  };

  const handleBookNow = () => {
    onClose(); // Close modal first
    if (onBookNow) {
      onBookNow(); // Call the book now handler from parent
    }
  };

  return (
    <div className="features-modal-overlay" onClick={onClose}>
      <div className="features-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="features-modal-header">
          <button className="features-modal-back" onClick={onClose}>
            ← Features
          </button>
          <div className="features-modal-search">
            <input 
              type="text" 
              placeholder="Search any features" 
              className="features-search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <span className="features-search-icon">🔍</span>
          </div>
        </div>

        {/* Category Tabs */}
        <div className="features-modal-tabs">
          {availableCategories.map(category => {
            const config = categoryConfig[category] || { label: category, icon: '📋' };
            return (
              <button
                key={category}
                className={`features-modal-tab ${activeCategory === category ? 'active' : ''}`}
                onClick={() => {
                  setActiveCategory(category);
                  setSearchQuery('');
                }}
              >
                {config.label}
              </button>
            );
          })}
        </div>

        {/* Content */}
        <div className="features-modal-content">
          <div className="features-modal-section">
            <h3 className="features-modal-section-title">
              <span className="features-section-icon">
                {categoryConfig[activeCategory]?.icon || '📋'}
              </span>
              {categoryConfig[activeCategory]?.label.toUpperCase() || activeCategory}
            </h3>

            <div className="features-modal-list">
              {getFilteredFeatures().length > 0 ? (
                getFilteredFeatures().map((feature, index) => (
                  <div key={index} className="features-modal-item">
                    <div className="features-item-content">
                      <span className={`features-check ${feature.available ? 'available' : 'unavailable'}`}>
                        {feature.available ? '✓' : '○'}
                      </span>
                      <span className="features-item-name">{feature.name}</span>
                      {feature.available && (
                        <span className="features-info-icon">ℹ️</span>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <p className="no-results">No features found matching "{searchQuery}"</p>
              )}
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="features-modal-footer">
          <button className="features-footer-btn book-now" onClick={handleBookNow}>
            BOOK NOW
            <span className="btn-subtitle">100% refundable</span>
          </button>
          <button className="features-footer-btn test-drive" onClick={handleTestDrive}>
            FREE TEST DRIVE
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopFeaturesModal;